import { render, staticRenderFns } from "./ShortcutPanel.vue?vue&type=template&id=61fc3e75&scoped=true"
import script from "./ShortcutPanel.vue?vue&type=script&lang=js"
export * from "./ShortcutPanel.vue?vue&type=script&lang=js"
import style0 from "./ShortcutPanel.vue?vue&type=style&index=0&id=61fc3e75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fc3e75",
  null
  
)

export default component.exports